import React from "react";
import { Outlet } from "react-router";

const ClientAuthLayout = () => {
  return (
    <div className="w-screen h-screen bg-[#ffffff]">
      <Outlet />
    </div>
  );
};

export default ClientAuthLayout;
